<template>
  <div class="flex" :class="{ mobile: isMobile }">
    <!-- 左侧图片 -->
    <div class="left_login">
      <img src="" alt="">
      <div class="left_placeholder">
        <!-- <img src="@/assets/images/login-background.jpg" alt=""> -->
      </div>
    </div>

    <!-- 右侧登录框 -->
     <div class="right_login">
        <div class="welcome_text">
          <div style="font-size: 25px;">Welcome to {{ $store.state.utop.MainName || 'Honor Pos' }} :)</div>
          <div v-if="isMobile" style="color: rgb(132 132 132);margin-top: 12px;font-size: 12px;">Please sign-in to your account and start the adventure</div>
          <div v-else style="color: rgb(132 132 132);margin-top: 12px;">Please enter the verification code to complete the login</div>
        </div>

        <el-divider></el-divider>
        <div class="text_input">
          <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
            <el-form-item prop="phone">
              <el-input v-model="loginForm.phone" @input="formatPhoneNumber" maxlength="14" placeholder="Phone Number*"></el-input>
            </el-form-item>
            <el-form-item prop="code">
              <el-input placeholder="Verification Code*" v-model="loginForm.code">
                <template slot="append">
                  <div
                    type="primary"
                    @click="getCodeImg"
                    :disabled="isCounting"
                  >
                    {{ isCounting ? `${countdown}s` : 'get code' }}
                </div>
                </template>
              </el-input>
            </el-form-item>
            <!-- <el-input v-model="code" placeholder="Verification code*" ></el-input> -->
          </el-form>
        </div>

        <div class="remember_btn">
          <!-- <el-checkbox v-model="loginForm.rememberMe">Remember Me</el-checkbox> -->
        </div>
        <el-button type="danger" class="login_btns_1" @click="login">LOGIN</el-button>

        <el-divider><div style="color: #b1adad;font-weight: 600;">or</div></el-divider>

        <div class="longin_btns">

          <div class="gmaillogin_btn" @click="gogologin">
            <img src="@/assets/logo/Gmail.png" alt="">
            <div>Gmail</div>
          </div>

        </div>

     </div>
  </div>
</template>

<script>
import { login, getCodeImg, gogo, emalogin, selecustorder, getInfo } from '@/api/login'
import store from '@/store/index'
import { getToken, setToken, removeToken } from '@/utils/auth'

export default {
  name: 'HomeView',
  directives: {
    'us-phone-format': {
      inserted (el, binding, vnode) {
        const input = el.querySelector('input')
        const handler = function (e) {
          let value = this.value.replace(/\D/g, '')

          if (value.length > 0) {
            value = value.substring(0, 10)

            if (value.length <= 3) {
              value = value
            } else if (value.length <= 6) {
              value = `(${value.substring(0, 3)}) ${value.substring(3)}`
            } else {
              value = `(${value.substring(0, 3)}) ${value.substring(3, 6)}-${value.substring(6, 10)}`
            }
          }

          this.value = value

          if (vnode.componentInstance && vnode.componentInstance.$emit) {
            vnode.componentInstance.$emit('input', value)
          }
        }

        input.addEventListener('input', handler)
        el._phoneInputHandler = handler
      },
      unbind (el) {
        const input = el.querySelector('input')
        if (input && el._phoneInputHandler) {
          input.removeEventListener('input', el._phoneInputHandler)
          delete el._phoneInputHandler
        }
      }
    }
  },
  data () {
    // 验证手机号格式（10位数字）
    const validateUSPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Phone number is required'))
      }

      // Clean formatting
      const cleaned = value.replace(/\D/g, '')

      // Validate 10-digit US phone number
      const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/

      if (!phoneRegex.test(value) || cleaned.length !== 10) {
        callback(new Error('Please enter your 10-digit mobile phone number.'))
      } else {
        callback()
      }
    }

    return {
      iscode: false,
      isMobile: false,
      googleToken: null,
      countdown: 0,
      isCounting: false,
      loginForm: {
        phone: '',
        rememberMe: false,
        code: '',
        uuid: ''
      },

      loginRules: {
        phone: [
          { required: true, trigger: 'blur', message: 'Please enter your mobile phone number.' },
          { validator: validateUSPhone, trigger: 'blur' }
        ],
        code: [{ required: true, trigger: 'change', message: 'Please enter the verification code.' }
        ]
      }
    }
  },
  methods: {
    setIsMobile () {
      this.isMobile = window.innerWidth <= 800
    },
    checkPhone () {

    },
    getCleanedPhone () {
      return this.loginForm.phone.replace(/\D/g, '')
    },
    // Format phone number display (123) 456-7890
    formatPhoneNumber () {
      let value = this.loginForm.phone.replace(/\D/g, '')

      if (value.length > 0) {
        value = value.substring(0, 10) // Limit to 10 digits

        // Format: (123) 456-7890
        if (value.length <= 3) {
          value = value
        } else if (value.length <= 6) {
          value = `(${value.substring(0, 3)}) ${value.substring(3)}`
        } else {
          value = `(${value.substring(0, 3)}) ${value.substring(3, 6)}-${value.substring(6, 10)}`
        }
      }

      this.loginForm.phone = value
    },
    async getCodeImg () {
      console.log('this.loginForm.phone', this.loginForm.phone)
      if (this.isCounting) return

      // 验证手机号
      if (!this.getCleanedPhone() || this.getCleanedPhone().length !== 10) {
        this.$message.error('Please enter your 10-digit mobile phone number.')
        return
      }
      const data = { phone: this.getCleanedPhone() }
      try {
        // 开始倒计时
        this.startCountdown()
        const response = await getCodeImg(data)
        this.$message.success('Verification code sent successfully')
        this.iscode = true
      } catch (error) {
        this.$message.error('Verification code sending failed')
      }
    },

    // 开始倒计时
    startCountdown () {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
      }

      this.countdown = 60
      this.isCounting = true

      this.countdownTimer = setInterval(() => {
        if (this.countdown <= 1) {
          clearInterval(this.countdownTimer)
          this.countdown = 0
          this.isCounting = false
          this.countdownTimer = null
        } else {
          this.countdown--
        }
      }, 1000)
    },
    async getselecustorder () {
      const getselecustorder = await getInfo()
      if (getselecustorder.code == 200) {
        this.$store.commit('SET_USERINFO', getselecustorder.user)
      }
      console.log('selecustorder', getselecustorder)
    },
    login () {
      // 验证表单
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          // 表单验证通过，执行登录操作
          try {
            const loginresponse = await login(this.getCleanedPhone(), this.loginForm.code)
            if (loginresponse.code != 200) return
            // console.log('登录成功:', loginresponse);
            localStorage.setItem('user', JSON.stringify(loginresponse.user))
            setToken(loginresponse.token)
            this.$store.dispatch('GetInfo')
            this.$store.dispatch('initBusinessSetting')
            await this.getselecustorder()
            // console.log('store.state.user',store.state.user)

            // 跳转页面到menu
            this.$router.replace('/')
          } catch (error) {

          }
        }
      })
    },
    // 获取 access_token
    getAccessToken () {
      const currentUrl = window.location.href
      console.log('Current URL:', currentUrl)

      // Extract token from either query string or hash
      const params = this.searchParams(currentUrl)
      const googleToken = params.token || params.access_token

      return { googleToken }
    },
    async emalogin () {
      try {
        if (!this.googleToken) {
          const tokenObj = this.getAccessToken()
          this.googleToken = tokenObj.googleToken
        }
        console.log('this.googleToken', this.googleToken)
        const emaloginres = await emalogin(this.googleToken)
        // console.log('登录成功:', loginresponse);

        localStorage.setItem('user', JSON.stringify(emaloginres.data.user))
        setToken(this.googleToken)
        this.$store.dispatch('GetInfo')
        this.$store.dispatch('initBusinessSetting')
        await this.getselecustorder()

        // 跳转页面到menu
        this.$router.replace('/')
      } catch (error) {
      }
    },
    async gogologin () {
      gogo().then((gogores) => {
        if (gogores.code == 200) {
          window.location.href = gogores.data.googleAuthUrl
        }
      })
    },
    searchParams (url, key) {
      const params = {}
      // Extract query parameters from hash or search
      const queryString = url.includes('?') ? url.split('?')[1] : (url.includes('#') ? url.split('#')[1] : '')

      if (queryString) {
        // Remove any path after the query parameters
        const cleanQuery = queryString.split('#')[0]

        cleanQuery.split('&').forEach(param => {
          const [paramKey, paramValue] = param.split('=')
          if (paramKey) {
            params[decodeURIComponent(paramKey)] = decodeURIComponent(paramValue || '')
          }
        })
      }

      return params
    }
  },
  mounted () {
    const tokenObj = this.getAccessToken()
    this.googleToken = tokenObj.googleToken

    if (this.googleToken) {
      setToken(this.googleToken)
      // this.emalogin();
    }

    this.setIsMobile()
    window.addEventListener('resize', this.setIsMobile)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setIsMobile)
    // 清理倒计时定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer)
    }
  }
}
</script>

<style scoped lang="scss">
  .flex{
    display: flex;
    height: 100%;
  }

  .left_login{
    width: 60%;
    border-right: 1px solid #eee;
    background-image: url('@/assets/images/login_pc.jpg');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }

  .right_login{
    flex: 1;
    padding: 10px 5%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .welcome_text{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom:20px;
  }

  .text_input{
    display: flex;
    flex-direction: column;
    justify-content: space-between;

  }
  :deep(.el-input--medium .el-input__inner) {
    height: 50px;
    border: 1px solid #c0c4cc;
  }

  .remember_btn{
    width: 100%;
    display: flex;
    margin: 15px 0;
  }

  :deep(.el-checkbox__input.is-checked .el-checkbox__inner){
    background: #ff6d8a;
    border-color: #ff6d8a;
  }

  :deep(.el-checkbox__input.is-checked + .el-checkbox__label){
    color:#777777;
  }

  :deep(.el-button--danger){
    background-color: #ff6d8a;
    border-color: #ff6d8a;
    width: 150px;
    height: 40px;
    border-radius: 8px;
  }

  :deep(.el-button.is-plain:hover, .el-button.is-plain:focus){
    background: #FFFFFF;
    border-color: #ff6d8a;
    color: #ff6d8a;
  }

  :deep(.el-divider--horizontal){
    margin: 15px 0;
  }

  .longin_btns{
    display: flex;
  }

  .login_btns_1{
    font-size: 12px;
    font-weight: 600;
    border-radius: 8px;
  }

  .gmaillogin_btn{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    width: 120px;
    cursor: pointer;
    margin-top: 15px;
    background-color: #fafafa;
    border-radius: 20px;
    font-size: 15px;

    img{
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }

  /* Mobile-specific styles when `isMobile` is true */
  .flex.mobile{
    flex-direction: column;
  }

  .flex.mobile .left_login{
    width: 100%;
    border-right: none;
    min-height: 220px;
    height: 220px;
    background-image: url('@/assets/images/login_phone.jpg');
    background-size: cover;
    background-position: center top;
    display: block;
  }

  .flex.mobile .left_login > *{
    display: none; /* hide inner placeholder/text so banner shows clean */
  }

  .flex.mobile .right_login{
    padding: 20px 20px 40px 20px;
    align-items: stretch;
  }

  .flex.mobile .welcome_text{ align-items: flex-start; }

  .flex.mobile .text_input{ width: 100%; }

  .flex.mobile :deep(.el-input--medium .el-input__inner){ height:56px; }

  .flex.mobile .longin_btns{ gap:12px; display:flex; justify-content:space-between }

  .flex.mobile .login_btns_1{ width: 100%; height:48px }

  .flex.mobile .gmaillogin_btn{ width:100%; font-size:18px; padding:14px }

</style>
